import { X_AUTH_TOKEN } from '../utillities/CONSTANT_COOKIES'
import { getCookie } from '../utillities/Cookies'
import { getIsServer } from '../utillities/getIsServer'

const useIsLogin = () => {
  return getIsServer() ? false : !!getCookie(X_AUTH_TOKEN)
}
export default useIsLogin
